<template>
  <b-container fluid>
    <b-container v-if="planType">
      <h4 class="title-typography-color">
        <i aria-hidden="true" class="fas fa-file-invoice-dollar mr-2"></i>Resumen
      </h4>
      <hr class="title-typography-color dot-typography" />
      <b-list-group>
        <b-list-group-item class="d-flex justify-content-between align-items-center border-0">
          <h6>Tu plan:</h6>
          <b-badge v-if="planType" class="cursor-point" pill variant="success" @click="openModalPlanTypeInfo">
            {{ planType.name }}
          </b-badge>
          <b-button v-if="planType.type !== 'PREMIUM' && planType.type !== 'ADHOC'" variant="primary"
            @click="openChangePlan">Cambiar plan
          </b-button>
        </b-list-group-item>
        <b-list-group-item class="d-flex justify-content-between align-items-center border-0">
          <h6>Desglose:</h6>
        </b-list-group-item>
        <b-list-group-item class="d-flex justify-content-between align-items-center border-0">
          <b-table :fields="fields" :items="accountBillingProducts" borderless outlined>
          </b-table>
        </b-list-group-item>
        <b-list-group-item class="d-flex justify-content-between align-items-center border-0">
          <h6>Total cargo acumulado:</h6>
          <b-badge pill variant="success">{{ totalPending }} €</b-badge>
          <b-button variant="primary">Pagar</b-button>
        </b-list-group-item>
      </b-list-group>
    </b-container>
    <b-container>
      <h4 class="title-typography-color">
        <i aria-hidden="true" class="fas fa-file-invoice mr-2"></i>Facturas
      </h4>
      <hr class="title-typography-color dot-typography" />
      <v-data-table :footer-props="{
        showFirstLastPage: true,
        firstIcon: 'fas fa-arrow-left',
        lastIcon: 'fas fa-arrow-right',
        prevIcon: 'fas fa-minus',
        nextIcon: 'fas fa-plus',
        'items-per-page-options': [10, 25, 50],
      }" :headers="headersCitas" :items="invoiceCitas" item-key="id">
        <template v-slot:item.status="{ item }">
          <b-badge v-if="item.total === 0" class="text-uppercase" pill variant="warning">
            {{
              $t(
                "public.components.organization.preferences.preferences.included"
              )
            }}
          </b-badge>
          <b-badge v-else-if="
            item.billing &&
            item.billing.payment &&
            item.billing.payment.paymentStatus === 'PENDING' &&
            item.billing.payment.paymentMode === 'BANK_TRANSFER'
          " class="text-uppercase" pill variant="success">
            {{
              $t(
                "public.components.organization.preferences.preferences.unvalidated"
              )
            }}
          </b-badge>
          <b-badge v-else-if="
            item.billing &&
            item.billing.payment &&
            item.billing.payment.paymentStatus === 'SUCCESS'
          " class="text-uppercase" pill variant="success">
            {{
              $t("public.components.organization.preferences.preferences.paid")
            }}
          </b-badge>
          <b-badge v-else-if="
            item.billing &&
            item.billing.payment &&
            item.billing.payment.paymentStatus === 'PENDING'
          " class="text-uppercase" pill variant="danger">
            {{
              $t(
                "public.components.organization.preferences.preferences.pending"
              )
            }}
          </b-badge>
        </template>
        <template v-slot:item.price="{ item }">
          {{ item.total.toFixed(2) }} €
        </template>
        <template v-slot:item.month="{ item }">
          {{ myMonthFormatInfo(item.month) }}
        </template>
        <template v-slot:item.actions="{ item }">
          <div class="div-table-data">
            <button v-if="
              item.billing &&
              item.billing.payment &&
              item.billing.payment.paymentStatus === 'PENDING' &&
              item.billing.payment.paymentMode !== 'BANK_TRANSFER' &&
              item.total !== 0
            " :id="'btnPayInvoice' + item.id" class="item" v-on:click="payInvoice(item.id)">
              <i class="ri-bank-card-line"></i>
            </button>
            <b-popover v-if="
              item.billing &&
              item.billing.payment &&
              item.billing.payment.paymentStatus === 'PENDING'
            " :target="'btnPayInvoice' + item.id" placement="botton" triggers="hover focus">
              <template #title>{{
                $t(
                  "public.components.organization.preferences.preferences.payInvoice"
                )
              }}
              </template>
            </b-popover>
            <button :id="'btnDownload' + item.id" class="item" v-on:click="downloadInvoice(item.id)">
              <i class="ri-file-download-line"></i>
            </button>
            <b-popover :target="'btnDownload' + item.id" placement="botton" triggers="hover focus">
              <template #title>{{
                $t(
                  "public.components.organization.preferences.preferences.donwloadInvoice"
                )
              }}
              </template>
            </b-popover>
            <button :id="'btnInfo' + item.id" class="item" v-on:click="infoInvoice(item)">
              <i class="ri-eye-line"></i>
            </button>
            <b-popover :target="'btnInfo' + item.id" placement="botton" triggers="hover focus">
              <template #title>{{
                $t(
                  "public.components.organization.preferences.preferences.moreInformation"
                )
              }}
              </template>
            </b-popover>
          </div>
        </template>
      </v-data-table>
    </b-container>
    <b-container>
      <h4 class="title-typography-color">
        <i aria-hidden="true" class="fas fa-file-invoice mr-2"></i>Forma de pago
        a CITA.IO
      </h4>
      <hr class="title-typography-color dot-typography" />
    </b-container>

    <b-modal id="modal-account-pricing" centered hide-footer size="xl">
      <template #modal-title>Cambiar plan</template>
      <template #modal-cancel>{{
        $t(
          "public.components.organization.preferences.preferences.modalPay.cancel"
        )
      }}
      </template>
      <PreferencesAccountPricing :planType="planType"></PreferencesAccountPricing>
    </b-modal>

    <b-modal id="modal-plan-type-info" centered hide-footer size="lg">
      <template #modal-title>{{
        $t(
          "public.components.organization.preferences.preferences.modalPlanType.title"
        )
      }}
      </template>
      <form action="#">
        <b-container v-if="planType">
          <b-row>
            <b-col cols="6">
              <b-form-group label-for="name">
                <template slot="label">
                  {{
                    $t(
                      "public.components.organization.preferences.preferences.modalPlanType.name"
                    )
                  }}
                </template>
                <ul class="list-group">
                  <li class="list-group-item">
                    {{ planType.name }}
                  </li>
                </ul>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group label-for="monthlyRate">
                <template slot="label">
                  {{
                    $t(
                      "public.components.organization.preferences.preferences.modalPlanType.monthPrice"
                    )
                  }}:
                </template>
                <ul class="list-group">
                  <li v-if="planType.monthlyRate !== -1" class="list-group-item">
                    {{ planType.monthlyRate }} €
                  </li>
                </ul>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6">
              <b-form-group label-for="monthlyRateMinutesMonoconferenceProfessional">
                <template slot="label">
                  {{
                    $t(
                      "public.components.organization.preferences.preferences.modalPlanType.videoMinsIncluded"
                    )
                  }}:
                </template>
                <ul class="list-group">
                  <li v-if="
                    planType.monthlyRateMinutesMonoconferenceProfessional !==
                    -1
                  " class="list-group-item">
                    {{ planType.monthlyRateMinutesMonoconferenceProfessional }}
                    Minutos
                  </li>
                </ul>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group label-for="monthlyRateMinutesMulticonferenceProfessional">
                <template slot="label">
                  {{
                    $t(
                      "public.components.organization.preferences.preferences.modalPlanType.multiVideoMinsIncluded"
                    )
                  }}:
                </template>
                <ul class="list-group">
                  <li v-if="
                    planType.monthlyRateMinutesMulticonferenceProfessional !==
                    -1
                  " class="list-group-item">
                    {{ planType.monthlyRateMinutesMulticonferenceProfessional }}
                    Minutos
                  </li>
                </ul>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6">
              <b-form-group label-for="priceCallPhone">
                <template slot="label">
                  {{
                    $t(
                      "public.components.organization.preferences.preferences.modalPlanType.reminderCalsPrice"
                    )
                  }}:
                </template>
                <ul class="list-group">
                  <li v-if="planType.priceCallPhone !== -1" class="list-group-item">
                    {{ planType.priceCallPhone }} €
                  </li>
                </ul>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="4">
              <b-form-group v-if="planType.priceMessageSms !== -1" label-for="priceMessageSms">
                <template slot="label">
                  {{
                    $t(
                      "public.components.organization.preferences.preferences.modalPlanType.reminderSmsPrice"
                    )
                  }}:
                </template>
                <ul class="list-group">
                  <li class="list-group-item">
                    {{ planType.priceMessageSms }} €
                  </li>
                </ul>
              </b-form-group>
            </b-col>
            <b-col cols="4">
              <b-form-group label-for="priceMessageWhatapp">
                <template slot="label">
                  {{
                    $t(
                      "public.components.organization.preferences.preferences.modalPlanType.reminderWhatsPrice"
                    )
                  }}:
                </template>
                <ul class="list-group">
                  <li v-if="planType.priceMessageWhatapp !== -1" class="list-group-item">
                    {{ planType.priceMessageWhatapp }} €
                  </li>
                </ul>
              </b-form-group>
            </b-col>
            <b-col cols="4">
              <b-form-group label-for="priceMinuteMonoconference">
                <template slot="label">
                  {{
                    $t(
                      "public.components.organization.preferences.preferences.modalPlanType.videoMinPrice"
                    )
                  }}:
                </template>
                <ul class="list-group">
                  <li v-if="planType.priceMinuteMonoconference !== -1" class="list-group-item">
                    {{ planType.priceMinuteMonoconference }} €
                  </li>
                </ul>
              </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="6">
              <b-form-group label-for="priceMinuteMulticonference">
                <template slot="label">
                  {{
                    $t(
                      "public.components.organization.preferences.preferences.modalPlanType.multiVideoMinPrice"
                    )
                  }}:
                </template>
                <ul class="list-group">
                  <li v-if="planType.priceMinuteMulticonference !== -1" class="list-group-item">
                    {{ planType.priceMinuteMulticonference }} €
                  </li>
                </ul>
              </b-form-group>
            </b-col>
            <b-col cols="6">
              <b-form-group label-for="priceMinuteRecording">
                <template slot="label">
                  {{
                    $t(
                      "public.components.organization.preferences.preferences.modalPlanType.recordingMinPrice"
                    )
                  }}:
                </template>
                <ul class="list-group">
                  <li v-if="planType.priceMinuteRecording !== -1" class="list-group-item">
                    {{ planType.priceMinuteRecording }} €
                  </li>
                </ul>
              </b-form-group>
            </b-col>
          </b-row>
        </b-container>
      </form>
    </b-modal>
  </b-container>
</template>
<script>
import { xray } from "../../config/pluginInit";

import validator from "vue-m-validator";
import moment from "moment";

import utilsService from "../../services/utils";
import organizationService from "../../services/organization";
import accountService from "../../services/account";
import invoiceService from "../../services/invoice";

import PreferencesAccountPricing from "../../components/organization/PreferencesAccountPricing";

export default {
  name: "OrganizationPreferenceAccount",
  props: {
    accountId: undefined,
    planType: undefined,
  },
  mounted() {
    xray.index();
    this.getOrganization();
    //:TODO tiene que usarse
    this.findAllInvoicesCitaById();
  },
  methods: {
    async getOrganization() {
      let self = this;

      organizationService.get(localStorage.getItem("organizationId")).then(
        (response) => {
          if (response) {
            this.organization = response.data;
            this.paypalClientId = response.data.paypalAccountClientId;
            this.paypalSecret = response.data.paypalAccountSecret;
            this.paypalValidate = response.data.paypalAccountValidate;
            this.stripeApi = response.data.stripeAccountApi;
            this.stripePublic = response.data.stripeAccountPublic;
            this.stripeValidate = response.data.stripeAccountValidate;
            this.getHistoryBetweenDates();
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "organizationService.get",
            module: "component-organization-preferencesAccount",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              organizationId: localStorage.getItem("organizationId")
            }),
          });
        },
        " "
      );
    },
    infoInvoice(item) {
      this.idInvoiceInfo = item.id;
      this.numberInvoiceInfo = item.invoiceNumber;
      this.conceptInvoiceInfo = item.concept;
      this.monthInvoiceInfo = this.myMonthFormatInfo(item.month);
      this.yearInvoiceInfo = item.year;
      this.totalInvoiceInfo = item.total.toFixed(2);
      this.dateInvoiceInfo = item.date;

      this.sellerInvoiceInfo = item.seller;
      this.buyerInvoiceInfo = item.buyer;
      this.itemsInvoiceInfo = item.items;
      this.billingInvoiceInfo = item.billing;

      this.$bvModal.show("modal-invoice-info");
    },
    downloadInvoice(id) {
      let self = this;

      this.$awn
        .asyncBlock(invoiceService.generatePdfInvoiceCita(id), (response) => {
          if (response) {
            var byteCharacters = atob(response.data.data);
            var byteNumbers = new Array(byteCharacters.length);
            for (var i = 0; i < byteCharacters.length; i++) {
              byteNumbers[i] = byteCharacters.charCodeAt(i);
            }
            var byteArray = new Uint8Array(byteNumbers);
            var file = new Blob([byteArray], {
              type: "application/pdf;base64",
            });
            var fileURL = URL.createObjectURL(file);

            var fileLink = document.createElement("a");

            fileLink.href = fileURL;
            fileLink.setAttribute("download", "factura.pdf");
            document.body.appendChild(fileLink);

            fileLink.click();
            this.$notify({
              group: "notificacions",
              title: this.$i18n.t(
                "public.components.organization.preferences.preferences.notifications.title"
              ),
              text: this.$i18n.t(
                "public.components.organization.preferences.preferences.notifications.desc"
              ),
              type: "success",
            });
            this.$bvModal.hide("modal-cita");
          }
        })
        .catch((error) => {
          utilsService.auditErrorFrontent({
            info: "invoiceService.generatePdfInvoiceCita",
            module: "component-organization-preferencesAccount",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              id: id
            }),
          });
        }, " ");
    },
    async findAllInvoicesCitaById() {
      let self = this;

      this.$awn.asyncBlock(
        organizationService.findAllInvoicesCitaById(
          localStorage.getItem("organizationId")
        ),
        (response) => {
          if (response) {
            self.invoiceCitas = response.data;
          }
        },
        (error) => {
          utilsService.auditErrorFrontent({
            info: "organizationService.findAllInvoicesCitaById",
            module: "component-organization-preferencesAccount",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              organizationId: localStorage.getItem("organizationId")
            }),
          });
        },
        " "
      );
    },
    createDataSummary() {
      let data = [
        {
          name: "Min. videoconferencia",
          quantity: this.accountHistory.minutes.monoconference,
          priceUnid:
            this.accountHistory.planType.priceMinuteMonoconference.toFixed(3) +
            " €",
          price: this.accountHistory.prices.monoconference.toFixed(2),
        },
        {
          name: "Min. multiconferencia",
          quantity: this.accountHistory.minutes.multiconference,
          priceUnid:
            this.accountHistory.planType.priceMinuteMulticonference.toFixed(3) +
            " €",
          price: this.accountHistory.prices.multiconference.toFixed(2),
        },
        {
          name: "Minutos de grabación",
          quantity: this.accountHistory.minutes.recording,
          priceUnid:
            this.accountHistory.planType.priceMinuteRecording.toFixed(3) + " €",
          price: this.accountHistory.prices.recording.toFixed(2),
        },
        {
          name: "Recordatorios SMS",
          quantity: this.accountHistory.releases.totalsSMS,
          priceUnid:
            this.accountHistory.planType.priceMessageSms.toFixed(3) + " €",
          price: this.accountHistory.releases.totalsPriceSMS.toFixed(2),
        },
        {
          name: "Recordatorios WhatsApp",
          quantity: this.accountHistory.releases.totalsWhatApp,
          priceUnid:
            this.accountHistory.planType.priceMessageWhatapp.toFixed(3) + " €",
          price: this.accountHistory.releases.totalsPriceWhatApp.toFixed(2),
        },
        {
          name: "Recordatorio teléfono",
          quantity: this.accountHistory.releases.totalsPhone,
          priceUnid:
            this.accountHistory.planType.priceCallPhone.toFixed(3) + " €",
          price: this.accountHistory.releases.totalsPricePhone.toFixed(2),
        },
        {
          name: "Profesionales",
          quantity: this.accountHistory.totalProfessionals,
          priceUnid: this.accountHistory.planType.monthlyRate.toFixed(2) + " €",
          price: this.accountHistory.totalPriceProfessionals.toFixed(2),
        },
      ];

      this.accountBillingProducts = data;
    },
    openChangePlan() {
      this.$bvModal.show("modal-account-pricing");
    },
    checkPermissionProfessional(permission, permissionType) {
      return utilsService.checkPermissionProfessional(
        permission,
        permissionType
      );
    },
    getTotalPending() {
      if (
        this.accountHistory &&
        this.accountHistory.prices &&
        this.accountHistory.releases
      ) {
        this.totalPending = (
          this.accountHistory.prices.monoconference +
          this.accountHistory.prices.multiconference +
          this.accountHistory.prices.recording +
          this.accountHistory.releases.totalsPricePhone +
          this.accountHistory.releases.totalsPriceSMS +
          this.accountHistory.releases.totalsPriceWhatApp +
          this.accountHistory.totalPriceProfessionals
        ).toFixed(2);
      }
    },
    getHistoryBetweenDates() {

      let self = this;
      let data = {
        id: this.organization.accountId,
        startDate: utilsService.adjustDateTime(moment()
          .startOf("month").format("DD/MM/YYYY HH:mm"), "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]"),
        endDate: utilsService.adjustDateTime(moment()
          .endOf("month").format("DD/MM/YYYY HH:mm"), "YYYY-MM-DD[T]HH:mm:ss.SSS[Z]"),
      };


      accountService
        .getHistoryBetweenDates(self.organization.accountId, data)
        .then((response) => {
          if (response) {
            self.accountHistory = response.data;
            self.getTotalPending();
            self.createDataSummary();
          }
        })
        .catch((error) => {
          utilsService.auditErrorFrontent({
            info: "accountService.getHistoryBetweenDates",
            module: "component-organization-preferencesAccount",
            httpStatus: error.response ? error.response.status : null,
            endpoint: window.location.href,
            request: JSON.stringify({
              accountId: self.organization.accountId, data: data
            }),
          });
        });
    },
    checkPermissionProfessional(permission, permissionType) {
      return utilsService.checkPermissionProfessional(
        permission,
        permissionType
      );
    },
    openModalPlanTypeInfo() {
      this.$bvModal.show("modal-plan-type-info");
    },
    myMonthFormatInfo(month) {
      if (month === 1) {
        return "Enero";
      }
      if (month === 2) {
        return "Febrero";
      }
      if (month === 3) {
        return "Marzo";
      }
      if (month === 4) {
        return "Abril";
      }
      if (month === 5) {
        return "Mayo";
      }
      if (month === 6) {
        return "Junio";
      }
      if (month === 7) {
        return "Julio";
      }
      if (month === 8) {
        return "Agosto";
      }
      if (month === 9) {
        return "Septiembre";
      }
      if (month === 10) {
        return "Octubre";
      }
      if (month === 11) {
        return "Noviembre";
      }
      if (month === 12) {
        return "Diciembre";
      }
      return "";
    },
  },
  computed: {
    isFormBankAccountErrors() {
      let errors = this.validator.getErrors("bankAccount");
      return errors && errors.length > 0;
    },
  },
  data() {
    return {
      organization: undefined,
      validator: validator,

      totalPending: 0,

      accountHistory: {},

      //Invoices cita
      invoiceCitas: [],

      bankAccount: "",
      bankAccountUse: "",

      //Payments client to organization
      stripeApi: "",
      stripePublic: "",
      stripeValidate: false,
      paypalClientId: "",
      paypalSecret: "",
      paypalValidate: false,

      idInvoicePay: "",
      // Invoice cita info
      idInvoiceInfo: "",
      numberInvoiceInfo: "",
      conceptInvoiceInfo: "",
      monthInvoiceInfo: "",
      yearInvoiceInfo: "",
      totalInvoiceInfo: "",
      dateInvoiceInfo: "",

      sellerInvoiceInfo: {},
      buyerInvoiceInfo: {},
      itemsInvoiceInfo: [],
      billingInvoiceInfo: {},

      accountBillingProducts: [],

      isFirstRun: true,

      //Invoices citas
      headersCitas: [
        {
          text: this.$i18n.t(
            "public.components.organization.preferences.preferences.headers.nº"
          ),
          sortable: true,
          value: "invoiceNumber",
        },
        {
          text: this.$i18n.t(
            "public.components.organization.preferences.preferences.headers.concept"
          ),
          value: "concept",
        },
        {
          text: this.$i18n.t(
            "public.components.organization.preferences.preferences.headers.price"
          ),
          value: "price",
        },
        {
          text: this.$i18n.t(
            "public.components.organization.preferences.preferences.headers.status"
          ),
          value: "status",
        },
        {
          text: "",
          value: "actions",
        },
      ],
      //Account
      fields: [
        {
          label: "",
          key: "name",
        },
        {
          label: "Cantidad",
          key: "quantity",
        },
        {
          label: "Precio/Unidad",
          key: "priceUnid",
        },
        {
          label: "Subtotal",
          key: "price",
        },
      ],
    };
  },
  components: { PreferencesAccountPricing },
};
</script>